<template>
  <SkeletonLoader
    show-animation
    data-testid="sidebar-loader"
    class="sidebar-loader"
  >
    <div />
    <div />
    <div />
    <div />
  </SkeletonLoader>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SkeletonLoader
  }
})
export default class SidebarLoader extends Vue {}
</script>

<style lang="less" scoped>
.sidebar-loader {
  div {
    height: 50px;
    width: 80%;
    border-radius: @size-radius-x200;
    margin: @size-spacing-x300 0;
    &:first-of-type {
      width: 50%;
      height: 32px;
      margin-top: 0;
    }
  }
}
</style>
